import Shelf, {ApiShelf} from '@/model/Shelf';
import Subsidiary, {ApiSubsidiary} from '@/model/Subsidiary';
import Warehouse, {ApiWarehouse, WarehouseFilters} from '@/model/Warehouse';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {parseGenericFilters} from '../meta/filters';
import {ApiSortsDerived} from '../meta/odata';


export enum ResourceLager {
  Lagerhalle = '/Lagerhalle',
  Niederlassung = '/Niederlassung',
  Lagerfach = '/Lagerfach',
}


export async function getWarehouses(
    filters: WarehouseFilters,
    sorts: ApiSortsDerived<ApiWarehouse>,
    limit: number | null = null,
    skip: number = 0,
    client?: number,
    customerId?: string,
): Promise<CombinedApiResponse<Warehouse[]>> {
  const convertedFilters = parseGenericFilters(filters);

  const response = await doApiRequest<ApiWarehouse[]>({
    module: Module.Lager,
    method: Method.Get,
    resource: ResourceLager.Lagerhalle,
    sorts,
    limit,
    skip,
    filters: convertedFilters,
    useCache: true,
    select: new Set(['Niederlassung', 'Bezeichnung', 'Lagerhalle']),
    client,
    customerId,
  });

  return [response.Data.map((apiWarehouse) => Warehouse.fromApi(apiWarehouse)), response.CountAll];
}

export async function getShelves(
    filters: WarehouseFilters, sorts: ApiSortsDerived<ApiShelf>,
    limit: number | null = null, skip: number = 0,
): Promise<CombinedApiResponse<Shelf[]>> {
  const convertedFilters = parseGenericFilters(filters);

  const response = await doApiRequest<ApiShelf[]>({
    module: Module.Lager,
    method: Method.Get,
    resource: ResourceLager.Lagerfach,
    sorts,
    limit,
    skip,
    filters: convertedFilters,
  });

  return [response.Data.map((apiShelf) => Shelf.fromApi(apiShelf)), response.CountAll];
}

export async function getShelf(
    id: number,
): Promise<Shelf | null> {
  const convertedFilters = parseGenericFilters({
    Lagerfach: id,
  });
  const response = await doApiRequest<ApiShelf[]>({
    module: Module.Lager,
    method: Method.Get,
    resource: ResourceLager.Lagerfach,
    limit: 1,
    filters: convertedFilters,
  });

  return response.Data.map((apiShelf) => Shelf.fromApi(apiShelf)).find(() => true) ?? null;
}

export async function getSubsidiaries(filters?: { client?: number, customerId?: string }): Promise<CombinedApiResponse<Subsidiary[]>> {
  const response = await doApiRequest<ApiSubsidiary[]>({
    module: Module.Lager,
    resource: ResourceLager.Niederlassung,
    method: Method.Get,
    useCache: true,
    client: filters?.client,
    select: new Set(['NiederlassungNr', 'Bezeichnung', 'Name1', 'Name2']),
    customerId: filters?.customerId,
  });

  return [response.Data.map((s) => Subsidiary.fromApi(s)), response.CountAll];
}
